const modality = ['Presencial', 'Virtual', 'Presencial y Virtual']

export default modality
